import { NgModule } from '@angular/core';
import { RouterModule, ROUTES, Routes } from '@angular/router';
import oldLinks from 'src/assets/json/redirects/old-links.json';

import { ContentfulService } from '../service/contentful.service';

var routes: Routes = [];

function routeFactoryUsingContentfulData(contentfulService: ContentfulService): Routes {
  var routesFromContentful: [] = [];

  const query = { 'fields.name': 'Redirect Links#NDC' };
  contentfulService &&
    contentfulService.getMenuContentWithItems(query).then((items) => {
      if (items[0] && items[0].fields && items[0]?.fields.jsonData) {
        routesFromContentful = items[0]?.fields.jsonData;
        // console.log('routesFromContentful : ', routesFromContentful);

        routes = [...routesFromContentful, ...routes];

        // console.log('routes : ', routes);
      }
    });

  // console.log('routes : ', routes);

  return routes;
}

function routeFactoryUsingLocalData(): Routes {
  var routesFromLocal: any = [];
  routesFromLocal = oldLinks;
  routes = [...routesFromLocal, ...routes];

  // console.log('routes : ', routes);

  return routes;
}
@NgModule({
  imports: [RouterModule.forRoot([])],
  exports: [RouterModule],
  providers: [
    {
      provide: ROUTES,
      deps: [ContentfulService],
      useFactory: routeFactoryUsingLocalData,
      multi: true
    }
  ]
})
export class AppInvalidRoutingModule {}
